export default "__VITE_ASSET__CdBiLq8g__"